import './main.css';
import '../App.css';
import { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faGem, faGamepad } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from 'react-redux';

function MessageModal({ message }) {
    let alramModal = useSelector((state) => { return state.alramModal.value })

    const [modal, setModal] = useState(false);
    const timeoutRef = useRef(null); // 기존 타이머를 저장할 ref

    useEffect(() => {
        console.log()
        if (alramModal > 0 && message?.msg?.length > 0) {
            const onChangeModal = () => {
                // 기존 타이머가 있으면 취소
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }

                setModal(true); // 새 모달 띄우기

                // 새 타이머 설정
                timeoutRef.current = setTimeout(() => {
                    setModal(false);
                    timeoutRef.current = null; // 타이머 초기화
                }, 1500);
            };
            onChangeModal()
        }
    }, [alramModal, message])

    return (
        <>
            {modal && (
                <div className={`buy-modal copy`} ref={timeoutRef}>
                    <div>
                        {
                            message?.code === 0
                                ?
                                <i className="fa-regular fa-circle-check" style={{ color: "#20B26C" }}></i>
                                :
                                <i className="fa-regular fa-circle-xmark" style={{ color: "#EF454A" }}></i>
                        }
                    </div>
                    <div>{message?.msg}</div>
                </div>
            )}
        </>
    );
}

export default MessageModal;
